import React from "react";
import { TFunction } from "i18next";
import { StyledLabel, StyledSelectInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import { useDispatch } from "react-redux";

import {
    CESAR_LOYALTY,
    GODIA_LOYALTY,
    SYNAPSY_LOYALTY,
    ZEROSIX_LOYALTY,
} from "@constants/index";

import { AppDispatch } from "../../../../../../redux/store";
import { setIsEdited } from "../../../../../../redux/slices/fidelitySlice";
import { FormStateApi, INPUT_ERROR_STYLE } from "../types";

type Props = {
    state: FormStateApi;
    isConsult: boolean;
    isExist: boolean;
    oneShop: boolean;
    fidelityData: any;
    dataFidelity: any;
    setFidelityChoiceIndex: (idx: number) => void;
    fetchModeOfSale: () => Promise<void>;
    t: TFunction;
};

function buildOptions(
    oneShop: boolean,
    hasFidelityData: boolean,
    t: TFunction
) {
    if (oneShop) {
        return [
            { label: t("Fidelity Synapsy"), value: SYNAPSY_LOYALTY },
            { label: t("Fidelity Zerosix"), value: ZEROSIX_LOYALTY },
            { label: t("Godia"), value: GODIA_LOYALTY },
        ];
    }
    if (hasFidelityData) {
        return [{ label: t("Fidelity Softavera"), value: CESAR_LOYALTY }];
    }
    return [
        { label: t("Fidelity Softavera"), value: CESAR_LOYALTY },
        { label: t("Fidelity Synapsy"), value: SYNAPSY_LOYALTY },
        { label: t("Fidelity Zerosix"), value: ZEROSIX_LOYALTY },
        { label: t("Godia"), value: GODIA_LOYALTY },
    ];
}

export default function LoyaltyTypeSelect({
    state,
    isConsult,
    isExist,
    oneShop,
    fidelityData,
    dataFidelity,
    setFidelityChoiceIndex,
    fetchModeOfSale,
    t,
}: Props) {
    const { values, errors, setValue, resetErrors } = state;
    const { choiceFidelity } = values;
    const dispatch = useDispatch<AppDispatch>();

    const options = buildOptions(oneShop, fidelityData.data.length > 0, t);

    const handleChange = (e: any) => {
        setValue("password", "");
        setValue("login", "");
        setValue("remark", "");
        setValue("user", "");
        setValue("dashboardLink", "");
        setValue("apiKey", "");
        dispatch(setIsEdited(true));
        setValue("choiceFidelity", e.label);
        setValue("designation", e.label);
        resetErrors();
        setFidelityChoiceIndex(e.value);
        if (e.value === CESAR_LOYALTY) {
            if (dataFidelity.Id === undefined) {
                fetchModeOfSale();
            } else {
                setValue("sortedVisibility", dataFidelity.sortedVisibility);
            }
        }
    };

    return (
        <AvGroup className={isConsult ? "pe-none__clz" : ""}>
            <StyledLabel
                className="required__clz mt-3"
                htmlFor="choiceFidelity"
            >
                {t("Loyalty")}
            </StyledLabel>

            <StyledSelectInput
                data-testid="fidelity-franchise-loyalty-type-select"
                value={
                    choiceFidelity === ""
                        ? null
                        : { label: choiceFidelity, value: choiceFidelity }
                }
                className={classnames("fed_inp_FRfidelityType", {
                    invalid__clz: errors.choiceFidelity || isExist,
                    "not-allowed-fidelity__clz": dataFidelity.Id !== undefined,
                })}
                onChange={handleChange}
                options={options}
                validate={{
                    required: {
                        value: true,
                        errorMessage: t("Please select a fidelity choice"),
                    },
                }}
                placeholder={t("Select")}
                name="mark"
                noOptionsMessage={() => t("No options")}
                autoFocus={dataFidelity.Id === undefined}
            />
            {errors.choiceFidelity ? (
                <div style={INPUT_ERROR_STYLE}>
                    {t("Please select a fidelity type")}
                </div>
            ) : null}
            {isExist ? (
                <div style={INPUT_ERROR_STYLE}>
                    {choiceFidelity.startsWith(t("Fidelity Softavera"))
                        ? t("Loyalty type and group combination already exists")
                        : t("Loyalty already exists")}
                </div>
            ) : null}
        </AvGroup>
    );
}
